<nz-modal
  [(nzVisible)]="isModalVisible"
  nzTitle="Column Picker"
  (nzOnCancel)="hanldeCancelClick()"
  nzWrapClassName="vertical-center-modal"
  nzClassName="column-picker-modal-container"
  nzWidth="800px"
  nzHeight="688px"
  [nzFooter]="null"
>
<ng-container *nzModalContent>
  <va-item-picker
    *ngIf="hasDragColumnObserver()"
    [items]="data"
    resetBtnText="Reset to default"
    (onApply)="hanldeApplyClick($event)"
    (onReset)="hanldeResetClick()"
    (onCancel)="hanldeCancelClick()"
    (onDragItem)="handleColumnDrag($event)"
  >
  </va-item-picker>
  <va-item-picker
    *ngIf="!hasDragColumnObserver()"
    [items]="data"
    resetBtnText="Reset to default"
    (onApply)="hanldeApplyClick($event)"
    (onReset)="hanldeResetClick()"
    (onCancel)="hanldeCancelClick()"
  >
  </va-item-picker>
  </ng-container>
</nz-modal>
